import React from 'react';
import { Redirect } from 'react-router-dom';
import { matchPath } from "react-router";
import * as api from 'api/Console';
import * as auth from 'Auth';
import * as paths from 'Paths';
import * as urlUtils from 'utils/Url';
import * as marketingUtils from 'utils/Marketing';
import constants from 'Constants';
import consoleStore from 'stores/Console/ConsoleStore';
import { Sidebar } from 'containers/Console/Sidebar';


export class BaseConsoleRoute extends React.Component {
  constructor (props) {
    super(props);
  }

  componentDidMount() {
    const successCallback = (response) => {
      consoleStore.deserialize(response);

      const user = consoleStore.user;
      auth.setIsVerified(user.isVerified);

      // web tracking
      marketingUtils.identify(consoleStore);
    }

    const errorCallback = (errors) => {};
    if (auth.isLoggedIn()) {
      api.getConsoleContext(successCallback, errorCallback);
    };
  }

  getTheme = () => {
    const qs = urlUtils.parseQueryString(this.props.location.search);
    let theme = qs.theme;
    if (!theme) theme = auth.getCurrentProduct();
    return theme;
  };

  getSidebarForTheme = () => {
    let theme = this.getTheme();

    if (theme === constants.PRODUCT_MARKETING_PLATFORM) return Sidebar.MarketingPlatform;
    if (theme === constants.PRODUCT_REVIEWS) return Sidebar.Reviews;
    if (theme === constants.PRODUCT_AOV_PROGRESS_BAR) return Sidebar.AovProgressBar;
    if (theme === constants.PRODUCT_BACK_IN_STOCK) return Sidebar.BackInStock;
    if (theme === constants.PRODUCT_REPERKS) return Sidebar.Reperks;
    if (theme === constants.PRODUCT_RECOMMENDER) return Sidebar.Recommender;
    if (theme === constants.PRODUCT_PROMPT) return Sidebar.Prompt;
    return Sidebar.Default;
  };

  getSidebarConstant = () => {
    let theme = this.getTheme();

    if (theme === constants.PRODUCT_MARKETING_PLATFORM) return constants.MARKETING_PLATFORM_SIDEBAR;
    if (theme === constants.PRODUCT_REVIEWS) return constants.REVIEWS_SIDEBAR;
    if (theme === constants.PRODUCT_AOV_PROGRESS_BAR) return constants.AOV_PROGRESS_BAR_SIDEBAR;
    if (theme === constants.PRODUCT_BACK_IN_STOCK) return constants.BACK_IN_STOCK_SIDEBAR;
    if (theme === constants.PRODUCT_REPERKS) return constants.REPERKS_SIDEBAR;
    if (theme === constants.PRODUCT_RECOMMENDER) return constants.RECOMMENDER_SIDEBAR;
    if (theme === constants.PRODUCT_PROMPT) return constants.PROMPT_SIDEBAR;
    return {};
  };
}


//============================================
// Decorators
//============================================
function invokeCheckLogin() {
  const result = {};
  result.valid = true;

  if (!auth.isLoggedIn()) {
    const qs = {};
    qs['next'] = encodeURIComponent(urlUtils.currentURL());
    const url = urlUtils.appendQueryString(paths.getPathLogin(), qs);

    result.valid = false;
    result.redirectPath = url;
  }

  return result
}


export const checkLogin = (WrappedComponent) => {
  return class CheckLogin extends React.Component {
    render() {
      const account = consoleStore.account;
      const result = invokeCheckLogin();

      // Is not logged in
      if (!result.valid) {
        return (
          <Redirect to={result.redirectPath} />
        );
      }

      const ignorePaths = [
        paths.getPathUnverified(),
        paths.getPathSetupUser(),
        paths.getPathProvisionAccount(),
        paths.getPathProvisionProduct(),
      ];

      if (ignorePaths.some((ignorePath) => matchPath(this.props.location.pathname, ignorePath))) {
        return <WrappedComponent {...this.props} />
      }

      // Is not verified
      if (!auth.isVerified()) {
        return (
          <Redirect to={paths.getPathUnverified()} />
        );
      }

      // Missing password
      if (auth.isMissingPassword()) {
        return (
          <Redirect to={paths.getPathSetupUser()} />
        );
      }

      // No account
      if (!auth.getAccountId()) {
        return (
          <Redirect to={paths.getPathProvisionAccount()} />
        );
      }

      // No active product
      let currentProduct = auth.getCurrentProduct();
      if (!currentProduct) {
        return (
          <Redirect to={paths.getPathProvisionProduct()} />
        );
      }

      return <WrappedComponent {...this.props} />
    }
  }
}


// Wrap decorator with another function if you need to pass arugments
// export const checkStaff = (args1, args2) => (WrappedComponent) => {
//   return class CheckStaff extends React.Component {
//     render() {
//       let result = auth.checkStaff();
//       if (!result.valid) {
//         return (
//           <Redirect to={result.redirectPath} />
//         );
//       }

//       return <WrappedComponent {...this.props} />
//     }
//   }
// }



